import React from "react";
import { Button, Card } from "react-bootstrap";
import "./UserLandingPage.css";
import courseCoverImage from "../../../assets/images/user-landing-page/courseImage.png";
import { courseTypes } from "constants/Constants";
import { color } from "@uiw/react-codemirror";
import classes from "./UserLandingPage.module.css";

const CourseCard = ({ course, handleRedirect, courseType }) => {
  const {
    courseImage = courseCoverImage,
    courseTitle,
    courseDescription,
    rating,
    courseDomain,
    courseProgress,
    courseId,
    startDate,
    endDate,
  } = course;

  const completedStyle = {
    background: "#288F5833",
    width: "40%",
    height: 23,
    top: "8px",
    left: "266px",
    gap: "4px",
    borderRadius: "4px",
    paddingTop: "4px",
    paddingRight: "8px",
    paddingBottom: "4px",
    paddingLeft: "8px",
    display: "flex",
    color: "#288F58",
  };

  const dotStyle = {
    minWidth: "5px",
    minHeight: "5px",
    backgroundColor: "#288F58",
    borderRadius: "50%",
    display: "inline - block",
  };

  return (
    <>
      <Card>
        <Card.Body className="p-0">
          <div
            className={`d-flex  justify-content-between  p-2 ${courseType === courseTypes.UPCOMING ? "" : "cursor-pointer"}  border w-100`}
            onClick={() => {
              if (courseType !== courseTypes.UPCOMING) {
                console.log("courseTypes", courseTypes.UPCOMING);
                handleRedirect(courseId);
              }
            }}
          >
            <img src={courseImage} className="w-50 " />

            <div className=" d-flex flex-column justify-content-between mx-3  w-100 ">
              <div className="d-flex  justify-content-between ">
                <p>{courseDomain}</p>

                <div
                  style={completedStyle}
                  className="d-flex justify-content-center align-items-center"
                >
                  <div className="" style={dotStyle}></div>
                  <div> {courseType}</div>
                </div>
              </div>
              <div className={classes.progressMainCon}>
                <div className={classes.progressCon}>
                  <div className={classes.total}></div>
                  <div
                    className={classes.progressAmount}
                    style={{
                      width: `${Number(courseProgress?.completionPercentage).toFixed(0)}%`,
                    }}
                  ></div>
                </div>
                <div className={classes.percentage}>
                  {courseProgress?.completionPercentage.toFixed(0)}%
                </div>
              </div>
              <div>
                {`${new Date(startDate).toDateString()} - 
                ${new Date(endDate).toDateString()}`}
              </div>
              <p className="text-dark fw-bold fs-4 mt-3 ">{courseTitle}</p>
            </div>
          </div>
        </Card.Body>
      </Card>
    </>
  );
};

export default CourseCard;
